import { render, staticRenderFns } from "./smeQucikInfo.vue?vue&type=template&id=bbcf842a&scoped=true&"
import script from "./smeQucikInfo.vue?vue&type=script&lang=js&"
export * from "./smeQucikInfo.vue?vue&type=script&lang=js&"
import style0 from "./smeQucikInfo.vue?vue&type=style&index=0&id=bbcf842a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcf842a",
  null
  
)

export default component.exports